import React, { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, TableContainer, Table, TableHead, IconButton, TableRow, TableCell, TableBody, TextField, Box, Button } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

interface MinMaxModalProps {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    signalListData: string[];
    minMaxValue: { [key: string]: { min?: string, max?: string } };
    handleChange: (event: React.ChangeEvent<HTMLInputElement>, type: string, row: string) => void;
    submitDisabled: boolean;
    faultDatatriggerPayload: (data: any) => void;
    tableData: any;
    faultDataPayload: (data: any) => void;
}

const MinMaxModal: React.FC<MinMaxModalProps> = (props) => {
    const inputRefs = useRef<{ [key: string]: HTMLInputElement | null }>({});

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, type: string, row: string) => {
        props.handleChange(event, type, row);
    };

    return (
        <Dialog
            open={props.modalOpen}
            onClose={() => props.setModalOpen(false)}
            PaperProps={{ style: { width: '40%' } }}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Signal Data Update
            </DialogTitle>
            <DialogContent>
                <TableContainer>
                    <Table aria-label="simple table" style={{ border: "1px solid #f6f6f6" }}>
                        <TableHead>
                            <IconButton
                                aria-label="close"
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                                onClick={() => { props.setModalOpen(false) }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <TableRow style={{ backgroundColor: '#F6F6F6' }}>
                                <TableCell style={{ width: '25%' }}>CHANNEL</TableCell>
                                <TableCell style={{ width: '25%' }}>MIN VALUE</TableCell>
                                <TableCell style={{ width: '25%' }}>MAX VALUE</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.signalListData.map((row: string, index: number) => (
                                <TableRow key={index}>
                                    <TableCell component="th" scope="row" style={{ width: '25%' }}>{row}</TableCell>
                                    <TableCell style={{ width: '25%' }}>
                                        <TextField
                                            label="MIN VALUE"
                                            name={`${row}_min`}
                                            onChange={(event: any) => handleChange(event, 'min', row)}
                                            value={props.minMaxValue[row]?.min || ''}
                                            type="number"
                                            inputRef={el => inputRefs.current[`${row}_min`] = el}
                                        />
                                    </TableCell>
                                    <TableCell style={{ width: '25%' }}>
                                        <TextField
                                            label="MAX VALUE"
                                            name={`${row}_max`}
                                            onChange={(event: any) => handleChange(event, 'max', row)}
                                            value={props.minMaxValue[row]?.max || ''}
                                            type="number"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-evenly"}
                alignItems={"center"}
                padding={'2%'}
            >
                <Button
                    variant='contained'
                    style={{ width: '25%' }}
                    disabled={props.submitDisabled}
                    onClick={() => { props.faultDatatriggerPayload(props.minMaxValue); props.setModalOpen(false); props.faultDataPayload(props.minMaxValue) }}
                >
                    Submit
                </Button>
            </Box>
        </Dialog>
    );
};

export default MinMaxModal;
